import { FIELD_TYPES } from "constants/template-field-type";

export default {
  tagsWidth: { type: FIELD_TYPES.TEXT, label: "Tags width (max 170px, min 140px)" }
};
